import { render, staticRenderFns } from "./WritingServices.vue?vue&type=template&id=7906fae4&scoped=true&"
import script from "./WritingServices.vue?vue&type=script&lang=js&"
export * from "./WritingServices.vue?vue&type=script&lang=js&"
import style0 from "./WritingServices.vue?vue&type=style&index=0&id=7906fae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7906fae4",
  null
  
)

export default component.exports